import {vh, startTypeShuffle, startWhichSizeVideo, toggleModalSketch} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateAboutInit() {

	const section2 = document.querySelector('.section-2');
	const section2Panel0 = document.querySelector('.section-2__panel--0');
	const section2Panel1 = document.querySelector('.section-2__panel--1');
	const section2Panel2 = document.querySelector('.section-2__panel--2');
	const section4Panel0 = document.querySelector('.section-4__panel--0');
	const section4Panel1 = document.querySelector('.section-4__panel--1');
	const section4Panel2 = document.querySelector('.section-4__panel--2');
	const section5Panel1 = document.querySelector('.section-5__panel--1');
	const section5Panel2 = document.querySelector('.section-5__panel--2');
	const section5Panel3 = document.querySelector('.section-5__panel--3');
	const section5Panel4 = document.querySelector('.section-5__panel--4');
	const section5Panel5 = document.querySelector('.section-5__panel--5');

	gsapContext.add(() => {

		let section2Ppanels = gsap.utils.toArray('.section-2__panel');

		/**
		 * Animations for section-2
		 */
		gsap.to(section2Ppanels, {
			ease:          'none',
			scrollTrigger: {
				trigger: section2,
				pin:     true,
				scrub:   0.1,
				end:     () => '+=' + vh(300), // total length of .section-1 = 1150vh
				//markers: true
			}
		});

		/**
		 * Animations for section-2__panel--0
		 */
		ScrollTrigger.create({
			trigger:     section2Panel0,
			start:       () => 'top top',
			end:         () => '+=' + vh(125),
			toggleClass: 'trigger-1',
			onEnter:     () => {

				startTypeShuffle(section2Panel0);
			},
			//markers:     true
		});

		/**
		 * Animations for section-2__panel--1
		 */
		gsap.to(section2Panel1, {
			left:          0,
			ease:          'none',
			scrollTrigger: {
				trigger: section2Panel1,
				start:   () => 'top+=' + vh(100) + ' top',
				end:     () => '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		ScrollTrigger.create({
			trigger:     section2Panel2,
			start:       () => 'top+=' + vh(200) + ' top',
			end:         () => '+=' + vh(200),
			toggleClass: 'trigger-1',
			onEnter:     () => {

				startTypeShuffle(section2Panel2);

				toggleModalSketch(section2Panel2, true);

				startWhichSizeVideo(section2Panel2);

			},
			onLeave:     ({progress, direction, isActive}) => {

				toggleModalSketch(section2Panel2, isActive);
			},
			//markers:     true
		});


		/**
		 * Pin animation for section-4 panels
		 */
		let section4Ppanels = gsap.utils.toArray('.section-4__panel');

		gsap.to(section4Ppanels, {
			ease:          'none',
			scrollTrigger: {
				trigger: '.section-4',
				pin:     true,
				scrub:   0.1,
				end:     () => '+=' + vh(500), // total length of .section-1 = 1150vh
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});


		/**
		 * Mask animation
		 */
		const section4Mask = document.getElementById('section-4-mask-path');

		if (section4Mask !== null)
		{
			const pathTo = section4Mask.dataset.pathTo;

			gsap.timeline({
				scrollTrigger: {
					trigger: section4Mask,
					start:   () => 'top top',
					end:     () => 'bottom top',
					scrub:   1,
					//markers: true
				}
			})
				.to(section4Mask, {
					ease: 'none',
					attr: {d: pathTo}
				});
		}

		/**
		 * Animations for section-1__panel--0 elements
		 */
		gsap.to(section4Panel0, {
			opacity:       0,
			ease:          'none',
			scrollTrigger: {
				trigger: section4Panel0,
				start:   () => 'top top',
				end:     () => '+=' + vh(100),
				scrub:   1
			}
		});

		/**
		 * Animations for section-4__panel--1 elements
		 */
		ScrollTrigger.create({
			trigger:     section4Panel1,
			start:       () => 'top+=' + vh(100) + ' top',
			end:         () => '+=' + vh(200),
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section4Panel1);
			},
			onToggle:    ({progress, direction, isActive}) => {
				toggleModalSketch(section4Panel1, isActive);

				startWhichSizeVideo(section4Panel1);
			},
			//markers:  true
		});

		/**
		 * Animations for section-4__panel--2 elements
		 */
		ScrollTrigger.create({
			trigger:     section4Panel2,
			start:       () => 'top+=' + vh(300) + ' top',
			end:         () => '+=' + vh(200),
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section4Panel2);
			},
			onToggle:    ({progress, direction, isActive}) => {
				toggleModalSketch(section4Panel2, isActive);

				startWhichSizeVideo(section4Panel2);
			},
			//markers:     true
		});


		/**
		 * Pin animation for section-5 panels
		 */
		let section5Ppanels = gsap.utils.toArray('.section-5__panel');

		/*gsap.to(section5Ppanels, {
			ease:          'none',
			scrollTrigger: {
				trigger: '.section-5',
				pin:     true,
				scrub:   0.1,
				end:     () => '+=' + vh(500), // total length of .section-1 = 1150vh
				//markers: true
			}
		});*/


		/**
		 * Animations for section-5__panel--1 elements
		 */
		ScrollTrigger.create({
			trigger:     section5Panel1,
			start:       () => 'top 75%',
			end:         () => 'bottom 75%',
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section5Panel1);
			},
			//markers:     true
		});

		let slideshowSwiper = new Swiper('.section-5 .swiper', {
			slidesPerView:     'auto',
			spaceBetween:      20,
			slidesOffsetAfter: 0,
			speed:             600,
			autoHeight:        true,
			autoplay:          {
				delay: 1000,
			},
			loop: true,
			centeredSlides: false
		});

		/**
		 * Animations for section-5__panel--2 elements
		 */
		ScrollTrigger.create({
			trigger:     section5Panel2,
			start:       () => 'top 75%',
			end:         () => 'bottom 75%',
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section5Panel2);
			},
			onToggle:    ({progress, direction, isActive}) => {
				toggleModalSketch(section5Panel2, isActive);
			},
			//markers:     true
		});

		/**
		 * Animations for section-5__panel--3 elements
		 */
		ScrollTrigger.create({
			trigger:     section5Panel3,
			start:       () => 'top 75%',
			end:         () => 'bottom 75%',
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section5Panel3);
			},
			//markers:     true
		});

		/**
		 * Animations for section-5__panel--4 elements
		 */
		ScrollTrigger.create({
			trigger:     section5Panel4,
			start:       () => 'top 75%',
			end:         () => 'bottom 75%',
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section5Panel4);
			},
			onToggle:    ({progress, direction, isActive}) => {
				toggleModalSketch(section5Panel4, isActive);
			}
			//markers:     true
		});

		/**
		 * Animations for section-5__panel--5 elements
		 */
		ScrollTrigger.create({
			trigger:     section5Panel5,
			start:       () => 'top 75%',
			end:         () => 'bottom 75%',
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section5Panel5);
			},
			//markers:     true
		});

	});
}